export interface FormikValuesChangePassword {
  newPass: string;
  confirmPass: string;
}

export enum ChangePasswordFormFields {
  newPass="newPass",
  confirmPass="confirmPass",
}